export const enqueueSnackbar = notification => ({
    type: 'ENQUEUE_SNACKBAR',
    notification: {
        key: new Date().getTime() + Math.random(),
        ...notification,
    },
});

export const enqueueSuccess = message => 
    enqueueSnackbar({
            message: message,
            options: {
                variant: 'success',
                autoHideDuration: '2000'                
            }});
;
export const enqueueWarning = message => 
    enqueueSnackbar({
            message: message,
            options: {
                variant: 'warning'
            }});
;

export const enqueueFailedRequestWarning = (message, err) => {
    let error = (err && err.response && err.response.data && err.response.data.error);
    if (!error) {

        console.log({ status: err.response && err.response.status });
        if (err.response && err.response.status === 403) 
            error = "You do not have the permissions to perform this request.";
        else if (err.response && err.response.status === 401)
            error = "You must log in to perform this request.";
        else {
            error = (err.toString ? err.toString() : "");
            if (err.response && err.response.statusText) {
                error += "(" + err.response.statusText + ")";
            }
        }
    }
    
    
    return enqueueSnackbar({
        message: message + " " + error,
        options: {
            variant: 'warning'
        }
    });
};

export const removeSnackbar = key => ({
    type: 'REMOVE_SNACKBAR',
    key,
});



// WEBPACK FOOTER //
// ./src/features/home/redux/snackActions.js